<template>
 <div>
     <the-nav>
         <div class="expedient-header h3">
             <div class="expedient-information">
                 <div title="Nombre del expediente"
                      class="btn btn-primary btn-icon badge"
                      @click="setAction('expedient-detail-change-name-modal')"
                      v-if="can('expedient.change-name')">
                     <span>{{ expedient.name }}</span>
                     <span class="uq-icon bi-pencil"></span>
                 </div>

                 <span title="Nombre del expediente"
                       class="badge bg-primary"
                       v-else>
                    {{ expedient.name }}
                </span>

                 <button class="btn btn-secondary"
                         title="Tipo de contrato"
                         @click="showChangeContractTypeModal('expedient-detail-change-contract-type-modal')"
                         v-if="can('expedient.change-contract-type')">
                     <span>{{ expedient.contract_type_display }}</span>
                     <span class="uq-icon bi-pencil"></span>
                 </button>

                 <span title="Tipo de contrato" class="badge bg-secondary" v-else>{{ expedient.contract_type_display }}</span>

                 <span title="Estado actual del expediente" class="badge bg-success">{{
                         getCurrentStatus(expedient.statuses) === null ? '*Sin estado' : getCurrentStatus(expedient.statuses).display_name
                     }}</span>

                 <div class="btn btn-edition clickable"
                      @click="setAction('change-responsible')">
                     <span class="h3">{{ expedient.responsible_display }}</span>
                     <span class="uq-icon bi-pencil"></span>
                 </div>
             </div>
         </div>
     </the-nav>

     <div v-if="statusComponent === 'loaded'">
         <div class="section-main">
             <div class="section-body">
                 <div class="form component-section w-100">
                     <div class="row expedient-status-header">
                         <div class="h4 col-12">
                             Histórico
                         </div>
                     </div>

                     <v-expedient-statuses-timeline :statuses="expedient.statuses"
                                                    @show-status="showStatus"
                                                    @edit-status="editStatus"
                                                    @delete-status="deleteStatus">
                     </v-expedient-statuses-timeline>

                     <div class="action-container">
                         <button class="btn btn-primary" @click="modalToShow = 'newStatus'"
                                 v-if="can('expedient.status.store')">Añadir estado
                         </button>
                     </div>
                 </div>

                 <div class="grid-template-header">

                 </div>

                 <div class="grid-template-body">
                     <div class="info-container">
                         <div class="form component-section template-section">
                             <div class="row">
                                 <div class="col-12">
                                     <h4>Plantillas disponibles</h4>
                                 </div>

                                 <div class="col-12 template-selector">
                                     <select class="form-select" aria-label="Plantilla" v-model="selectedTemplate">
                                         <option v-for="template in availableTemplates" :value="template">
                                             {{ template.display_name }}
                                         </option>
                                     </select>
                                 </div>

                                 <div class="col-12">
                                     <button class="btn btn-primary"
                                             :disabled="Object.keys(availableTemplates).length === 0 ? true : null"
                                             @click="useTemplate">Usar plantilla
                                     </button>
                                 </div>
                             </div>
                         </div>

                         <div class="form component-section">
                             <div class="row">
                                 <div class="col-12 d-flex align-items-center justify-content-between">
                                     <h4>Cliente <span class="badge bg-dark"
                                                       v-for="client in expedient.clients">{{ client.code }}</span></h4>

                                     <button class="btn btn-edit" @click="showUpdateEntityAndClientModal()"
                                             title="Editar cliente"
                                             v-if="can('entity.update')">
                                         <span class="uq-icon bi-pencil"></span>
                                     </button>

                                     <button class="btn btn-show" v-for="client in expedient.clients"
                                             title="Mostrar cliente"
                                             @click="showClient(client)"
                                             v-if="can('client.show')">
                                         <span class="uq-icon bi-eye"></span>
                                     </button>
                                 </div>
                             </div>

                             <div class="row content-container"
                                  v-for="client in expedient.clients">
                                 <div class="col-6 content-wrapper">
                                     <span class="content-text">{{ client.dni }}</span>
                                 </div>
                                 <div class="col-6 content-wrapper">
                                     <span class="content-text">{{ client.surname }}, {{ client.name }}</span>
                                 </div>
                                 <div class="col-6 content-wrapper">
                                    <span class="content-text">
                                        <a :href="'tel:' + client.phone_number_01">{{ client.phone_number_01 }}</a>
                                    </span>
                                 </div>
                                 <div class="col-6 content-wrapper">
                                    <span class="content-text">
                                        <a :href="'mailto:' + client.email_01">{{ client.email_01 }}</a>
                                    </span>
                                 </div>
                                 <div class="col-6 content-wrapper">
                                    <span class="content-text" v-if="!!client.phone_number_02">
                                        <a :href="'tel:' + client.phone_number_02">{{ client.phone_number_02 }}</a>
                                    </span>
                                 </div>
                                 <div class="col-6 content-wrapper">
                                    <span class="content-text" v-if="!!client.email_02">
                                        <a :href="'mailto:' + client.email_02">{{ client.email_02 }}</a>
                                    </span>
                                 </div>

                                 <div class="col-12 content-wrapper mt-2">
                                    <span class="content-text">
                                        <strong>Responsable:</strong>
                                        {{ client.responsible ? client.responsible.name : '*Sin responsable'}}
                                    </span>
                                 </div>
                             </div>
                         </div>

                         <div class="form component-section">
                             <div class="row">
                                 <div class="col-12 d-flex align-items-center justify-content-between"
                                      v-for="entity in expedient.entities">
                                     <h4>{{ entity.name }}</h4>

                                     <button class="btn btn-edit" @click="showUpdateEntityAndClientModal()"
                                             title="Editar entidad"
                                             v-if="can('entity.update')">
                                         <span class="uq-icon bi-pencil"></span>
                                     </button>

                                     <button class="btn btn-show" @click="showEntity(entity)"
                                             title="Mostrar entidad"
                                             v-if="can('entity.show')">
                                         <span class="uq-icon bi-eye"></span>
                                     </button>
                                 </div>
                             </div>
                         </div>

                         <expedient-detail-related-expedients :expedient="expedient" @related-expedient-created="loadExpedient"></expedient-detail-related-expedients>

                         <expedient-detail-burofaxes
                             :updateExpedient="updateExpedient"
                             :expedient="expedient"
                             @burofax_sent="loadExpedient"></expedient-detail-burofaxes>
                     </div>

                     <div class="expedient-data d-flex flex-column align-items-center justify-content-start">
                         <div class="col-12">
                             <div class="form component-section">
                                 <div class="row">
                                     <expedient-detail-form :expedient="expedient"
                                                            ref="detailForm"></expedient-detail-form>
                                 </div>
                             </div>
                         </div>

                         <div class="col-12">
                             <div class="form component-section">
                                 <div class="row">
                                     <div class="col-12">
                                         <button class="btn btn-default" @click="this.modalToShow = 'upload-files'">
                                             <span class="uq-icon bi-plus-circle-dotted"></span>
                                             Subir ficheros
                                         </button>
                                     </div>
                                 </div>
                                 <div class="row">
                                     <div class="col-4"
                                          v-for="element in expedient.media">
                                         <file-data-with-thumbnail :media="element"
                                                                   @deleteFile="deleteFile"
                                                                   @showMedia="doShowMedia"
                                                                   @changeMediaName="doChangeMediaName"
                                                                   @changeMediaCategory="doChangeMediaCategory">
                                         </file-data-with-thumbnail>
                                     </div>
                                 </div>
                             </div>
                         </div>
                     </div>
                 </div>
             </div>
         </div>
     </div>

     <div v-if="statusComponent === 'loading'">
         <div class="loader-container">
             <div class="loader"></div>
         </div>
     </div>

     <statuses-list-add-modal :expedientId="expedient.id" v-if="modalToShow === 'newStatus'"
                              @closed="modalToShow = null;"
                              @expedientStatusAdded="modalToShow = null; loadExpedient()"></statuses-list-add-modal>
     <statuses-list-show-modal v-if="modalToShow === 'show-status'" :status="status"
                               @closed="modalToShow = null"></statuses-list-show-modal>
     <statuses-list-edit-modal v-if="modalToShow === 'edit-status'" :status="status" :expedient="expedient"
                               @closed="modalToShow = null; loadExpedient()"
                               @accepted="modalToShow = null; loadExpedient();"></statuses-list-edit-modal>
     <statuses-list-delete-modal v-if="modalToShow === 'delete-status'" :status="status" :expedient="expedient"
                                 @closed="modalToShow = null; loadExpedient()"></statuses-list-delete-modal>

     <expedient-detail-change-responsible-modal v-if="modalToShow === 'change-responsible'"
                                                :responsible="expedient.responsible"
                                                @closed="modalToShow = null;"
                                                @responsible-changed="updateExpedientResponsible">
     </expedient-detail-change-responsible-modal>

     <expedient-detail-upload-files-modal v-if="modalToShow === 'upload-files'"
                                          :expedient="expedient"
                                          @closed="modalToShow = null;"
                                          @files-uploaded="modalToShow = null; loadExpedient();">
     </expedient-detail-upload-files-modal>

     <expedient-detail-change-media-name v-if="modalToShow === 'change-media-name'"
                                         :name="selectedMedia.name"
                                         :file-id="selectedMedia.id"
                                         :expedient-id="expedient.id"
                                         @closed="modalToShow = null; selectedMedia = null;"
                                         @name-changed="modalToShow = null; loadExpedient()">
     </expedient-detail-change-media-name>

     <expedient-detail-change-media-category v-if="modalToShow === 'change-media-category'"
                                             :name="selectedMedia.name"
                                             :category="selectedMedia.collection_name"
                                             :file-id="selectedMedia.id"
                                             :expedient-id="expedient.id"
                                             @closed="modalToShow = null; selectedMedia = null;"
                                             @category-changed="modalToShow = null; loadExpedient()">
     </expedient-detail-change-media-category>

     <expedient-detail-show-media v-if="modalToShow === 'show-media'"
                                  :name="selectedMedia.name"
                                  :base64="selectedMedia.storage_url"
                                  @closed="modalToShow = null; selectedMedia = null;">
     </expedient-detail-show-media>

     <clients-list-show-modal v-if="modalToShow === 'show-client'" :client="selectedClient"
                              @closed="modalToShow = null"></clients-list-show-modal>

     <entities-list-show-modal v-if="modalToShow === 'show-entity'"
                               :entity="selectedEntity"
                               @closed="modalToShow = null">
     </entities-list-show-modal>

     <expedient-detail-update-entity-modal v-if="modalToShow === 'update-entity-and-client'"
                                           :preselected-entity="expedient.entities[0].id"
                                           :preselected-client="expedient.clients[0].id"
                                           @updateEntityAndClient="updateEntityAndClient"
                                           @closed="modalToShow = null">
     </expedient-detail-update-entity-modal>

     <expedient-detail-change-contract-type-modal
         v-if="modalToShow === 'expedient-detail-change-contract-type-modal' && can('expedient.change-contract-type')"
         :contract-type="expedient.contract_type"
         @closed="modalToShow = null;"
         @contract-type-changed="updateContractType">
     </expedient-detail-change-contract-type-modal>

     <expedient-detail-change-name-modal
         v-if="modalToShow === 'expedient-detail-change-name-modal' && can('expedient.change-name')"
         :expedient-id="expedient.id"
         :name="expedient.name"
         :expedient-client="expedient.clients[0]"
         @updateExpedientName="loadExpedient"
         @closed="modalToShow = null;">
     </expedient-detail-change-name-modal>

     <router-view></router-view>
 </div>
</template>

<script>
import router from "../../../router";
import {can} from "../../../helpers/Permissions";
import StatusesListShowModal from "../../statuses/parts/StatusesListShowModal";
import StatusesListEditModal from "../../statuses/parts/StatusesListEditModal";
import StatusesListDeleteModal from "../../statuses/parts/StatusesListDeleteModal";
import TheNav from "../../layouts/TheNav";
import StatusesListAddModal from "../../statuses/parts/StatusesListAddModal";
import {getAvailableTemplates} from "../../../helpers/requests/RequestsTemplates";
import {getAvailableStatuses} from "../../../helpers/requests/RequestsAvailableStatuses";
import {
    getExpedient,
    updateClient,
    updateEntity,
    updateExpedientResponsible,
    updateContractType
} from "../../../helpers/requests/RequestsExpedients";
import ExpedientDetailChangeResponsibleModal from "./expedient-detail-parts/ExpedientDetailChangeResponsibleModal";
import {withTimeout} from "../../../helpers/requests/RequestsCore";
import {storeFormValues} from "../../../helpers/requests/RequestsFormValues";
import ExpedientDetailForm from "./expedient-detail-parts/ExpedientDetailForm";
import ExpedientDetailUploadFilesModal from "./expedient-detail-parts/ExpedientDetailUploadFilesModal";
import {deleteMedia,} from "../../../helpers/requests/RequestsMedia";
import ExpedientDetailChangeMediaName from "./expedient-detail-parts/ExpedientDetailChangeMediaName";
import ExpedientDetailBurofaxes from "./expedient-detail-parts/ExpedientDetailBurofaxes";
import ExpedientDetailChangeMediaCategory from "./expedient-detail-parts/ExpedientDetailChangeMediaCategory";
import ExpedientDetailShowMedia from "./expedient-detail-parts/ExpedientDetailShowMedia";
import FileDataWithThumbnail from "./media/FileDataWithTumbnail";
import VExpedientStatusesTimeline from "./expedient-detail-parts/VExpedientStatusesTimeline";
import ClientsListShowModal from "../../clients/parts/ClientsListShowModal";
import EntitiesListShowModal from "../../entities/parts/EntitiesListShowModal";
import ExpedientDetailUpdateEntityModal from "./expedient-detail-parts/ExpedientDetailUpdateEntityModal";
import ExpedientDetailChangeNameModal from "./expedient-detail-parts/ExpedientDetailChangeNameModal";
import ExpedientDetailChangeContractTypeModal from "./expedient-detail-parts/ExpedientDetailChangeContractTypeModal";
import ExpedientDetailAddExpedientModal from "./expedient-detail-parts/ExpedientDetailAddRelatedExpedientModal";
import ExpedientDetailRelatedExpedients from "./expedient-detail-parts/ExpedientDetailRelatedExpedients";
import {getCurrentStatus} from "../../../helpers/Expedient";

export default {
    name: "ExpedientDetail",
    props: ['expedient'],
    components: {
        ExpedientDetailRelatedExpedients,
        ExpedientDetailAddExpedientModal,
        ExpedientDetailChangeNameModal,
        ExpedientDetailBurofaxes,
        ExpedientDetailChangeContractTypeModal,
        ExpedientDetailUpdateEntityModal,
        VExpedientStatusesTimeline,
        FileDataWithThumbnail,
        ExpedientDetailShowMedia,
        ExpedientDetailChangeMediaCategory,
        ExpedientDetailChangeMediaName,
        ExpedientDetailUploadFilesModal,
        ExpedientDetailForm,
        ExpedientDetailChangeResponsibleModal,
        TheNav,
        StatusesListDeleteModal,
        StatusesListEditModal,
        StatusesListShowModal,
        StatusesListAddModal,
        ClientsListShowModal,
        EntitiesListShowModal
    },
    setup() {
        return {
            can,
            getCurrentStatus,
        }
    },
    data() {
        return {
            status: {
                data: 'stored',
            },

            statusComponent: 'loading',
            expedient: {},
            modalToShow: null,
            allFieldsClients: [],
            allFieldsEntities: [],

            availableTemplates: [],
            selectedTemplate: {},
            availableStatuses: [],

            selectedMedia: null,

            timers: {
                store_form: '',
            },

            form_json: {},
        }
    },
    async mounted() {
        await this.loadExpedient();
        await this.loadAvailableTemplates();
        await this.loadAvailableStatuses();

        this.statusComponent = 'loaded';

        this.allFieldsClients = require('../../../config/form_fields.json').clients;
        this.allFieldsEntities = require('../../../config/form_fields.json').entities;
    },
    methods: {
        dateToReadable(date) {
            let splitted = date.substr(0, 10).split('-');
            return splitted[2] + '/' + splitted[1] + '/' + splitted[0];
        },
        async loadAvailableTemplates() {
            this.availableTemplates = await getAvailableTemplates(true);
            // By default we select the first one
            this.selectedTemplate = this.availableTemplates[0];
        },
        async loadAvailableStatuses() {
            this.availableStatuses = await getAvailableStatuses();
        },
        async loadExpedient(without_images_base64 = true) {
            try {
                this.expedient = await getExpedient(router.currentRoute.value.params.expedient, without_images_base64);

                if (this.expedient.attachedExpedients.length > 0) {
                    this.expedient.expedients = this.expedient.attachedExpedients;
                }

                // Parse dates to know how many days have passed since the last status
                let prevStatus = null;
                for (let i in this.expedient.statuses) {
                    let status = this.expedient.statuses[i];
                    if (prevStatus === null) {
                        status.days_difference = 0;
                        prevStatus = status;
                    } else {
                        // If date exists, use date; if not, use created_at
                        let usePrevDate = prevStatus.date;
                        if (usePrevDate === null) {
                            usePrevDate = prevStatus.created_at.split('.')[0].replaceAll('T', ' ')
                        }

                        let useDate = status.date;
                        if (useDate === null) {
                            useDate = prevStatus.created_at.split('.')[0].replaceAll('T', ' ');
                        }

                        let prevDate = new Date(usePrevDate);
                        let date = new Date(useDate);

                        status.days_difference = Math.abs(parseInt((prevDate - date) / (1000 * 60 * 60 * 24)));
                        prevStatus = status;
                    }
                }

                this.form_json = this.expedient.form_values;
            } catch (e) {
                this.$store.dispatch('app/setErrorToastMessage', 'No se han podido cargar los datos del expediente');
            }
        },
        useTemplate() {
            router.push({
                name: 'expedient.template.data',
                params: {
                    expedient: router.currentRoute.value.params.expedient,
                    template: this.selectedTemplate.id,
                }
            })
        },
        async deleteFile(media) {
            if (confirm('¿Borrar definitivamente?')) {
                await deleteMedia(this.expedient.id, media.id);
            }

            await this.loadExpedient();
        },
        async updateEntityAndClient({client_id, entity_id}) {
            if (!!client_id) {
                await updateClient(this.expedient.id, client_id);
            }

            if (!!entity_id) {
                await updateEntity(this.expedient.id, entity_id);
            }

            this.modalToShow = null;
            await this.loadExpedient();
            this.$refs.detailForm.setFormValues();
        },
        showClient(client) {
            this.modalToShow = 'show-client';
            this.selectedClient = client;
        },
        showEntity(entity) {
            this.modalToShow = 'show-entity';
            this.selectedEntity = entity;
        },
        showUpdateEntityAndClientModal() {
            this.modalToShow = 'update-entity-and-client';
        },
        async doShowMedia(media) {
            this.selectedMedia = media;

            this.modalToShow = 'show-media';
        },
        doChangeMediaName(media) {
            this.selectedMedia = media;
            this.modalToShow = 'change-media-name';
        },
        doChangeMediaCategory(media) {
            this.selectedMedia = media;
            this.modalToShow = 'change-media-category';
        },
        async updateExpedientResponsible(responsible) {
            await updateExpedientResponsible(this.expedient.id, responsible);
            await this.loadExpedient();
            this.modalToShow = null;
        },
        async updateExpedient() {
            // TODO: Is this necessary? We will fire updates one by one: name, doc_status, type, etc. if we fire them
            this.expedient = {
                doc_status: 'saved',
            }

            try {
                (await axios.put(`/api/expedient/${this.expedient}`, this.expedient)).data;

                this.$store.dispatch('app/setToastMessage', 'Expediente guardado');

                await router.push({name: 'expedient.index'});

            } catch (e) {
                this.$store.dispatch('app/setErrorToastMessage', 'No se ha podido guardar el expediente');
            }
        },
        async showStatus(status) {
            this.modalToShow = 'show-status';
            this.status = status;
        },
        async editStatus(status) {
            this.modalToShow = 'edit-status';
            this.status = status;
        },
        async deleteStatus(status) {
            this.modalToShow = 'delete-status';
            this.status = status;
        },
        setAction(action) {
            this.modalToShow = action;
            this.status = action;
        },
        showChangeContractTypeModal(contract_type) {
            this.modalToShow = contract_type;
        },
        async updateContractType(contract_type) {
            await updateContractType(this.expedient.id, contract_type);
            await this.loadExpedient();
            this.modalToShow = null;
        },
        fireFormUpdated(e) {
            let name = e.target.name;
            let value = e.target.value;

            if (e.target.type === 'checkbox') {
                // As string to be stored in form_values table
                value = e.target.checked + "";
            }

            if (!!value) {
                this.form_json[name] = value;
            } else {
                // We delete it to be deleted on database
                delete this.form_json[name];
            }

            this.storeFormValuesWithTimeout();
        },
        storeFormValuesWithTimeout() {
            this.status.data = 'storing';
            this.timers.store_form = withTimeout(async () => {
                await storeFormValues({...this.form_json}, router.currentRoute.value.params.expedient);
                this.status.data = 'stored';
            }, this.timers.store_form, 500);
        }
    },
    watch: {
        $route(to, from) {
            if (to !== from) {
                location.reload();
            }
        }
    }
}
</script>
